import React, { createContext } from "react";
import fetchApi from "../fetchApi";

const SignUpContext = createContext();
export default SignUpContext;

export const SignUpContextProvider = ({ children }) => {
  const [data, setData] = React.useReducer(reducer, []);
  const [loading, setLoading] = React.useState(false);

  const send = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        const value = data[key].hasOwnProperty("value")
          ? data[key].value
          : data[key];
        formData.append(key, value);
      });

      const token = await getCaptchaToken();
      formData.append("recaptcha", token);

      const result = await fetchApi(
        "/users/register",
        {
          method: "post",
          body: formData,
        },
        false,
        false
      );
      return result;
    } catch (error) {
      console.error(error);
      return {
        code: 500,
        message: error?.message || "Unexpected error while sending the form.",
      };
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignUpContext.Provider value={{ data, setData, send, loading }}>
      {children}
    </SignUpContext.Provider>
  );
};

/*
 * action:
 * - {field: <string>, value: <any>}: Ajout d'une entrée
 * - {field: <string>, type: "remove"}: Supprimer une entrée
 */
const reducer = (state, action) => {
  switch (action.type) {
    case "remove":
      const { [action.field]: _, ...newState } = state;
      return newState;
    case "skill":
      const { skill = [] } = state;
      if (!Array.isArray(skill)) return { ...state, skill: [action.value] };
      if (skill.includes(action.value))
        return {
          ...state,
          skill: skill.filter(id => id !== action.value),
        };
      else return { ...state, skill: [...skill, action.value] };
    default:
      return { ...state, [action.field]: action.value };
  }
};

const getCaptchaToken = async () => {
  try {
    return await grecaptcha // eslint-disable-line no-undef
      .execute("6Ld6nL4UAAAAAOwPByKNLFptHKtgckCtWKf0gE8C", {
        action: "signup",
      });
  } catch (error) {
    console.error(error);
    return false;
  }
};
